let lazyInstance = null

/**
 * Lazy por seção: imagens só recebem src quando a seção entra na viewport.
 * Evita falso positivo do layout do hero e funciona com Owl/Swiper.
 */
export function initLazyImages(options = {}) {
	const rootMargin = options.rootMargin ?? '80px 0px'
	const activatedSections = new WeakSet()
	const loadedImages = new WeakSet()

	const loadImage = (img) => {
		if (loadedImages.has(img)) return
		const src = img.dataset.src
		if (!src) return

		img.src = src
		if (img.dataset.srcset) img.srcset = img.dataset.srcset
		img.removeAttribute('data-src')
		img.removeAttribute('data-srcset')
		loadedImages.add(img)
	}

	const activateSection = (section) => {
		if (activatedSections.has(section)) return
		activatedSections.add(section)
		section.querySelectorAll('.js-lazy-img[data-src]').forEach(loadImage)
	}

	const sectionObserver = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (entry.isIntersecting) {
					activateSection(entry.target)
					sectionObserver.unobserve(entry.target)
				}
			}
		},
		{ rootMargin, threshold: 0 }
	)

	document.querySelectorAll('[data-lazy-section]').forEach((section) => {
		sectionObserver.observe(section)
	})

	const scan = (root = document) => {
		const scope = root instanceof Element ? root : document
		scope.querySelectorAll('.js-lazy-img[data-src]').forEach((img) => {
			const section = img.closest('[data-lazy-section]')
			if (section && activatedSections.has(section)) {
				loadImage(img)
			}
		})
	}

	lazyInstance = {
		scan,
		activateSection,
		disconnect: () => sectionObserver.disconnect(),
	}

	return lazyInstance
}

export function getLazyImages() {
	return lazyInstance
}
